import _ from 'lodash';

const getSpecialServicesChanges = (passengers, originalPassengers) => {
  const changes = [];
  if (!originalPassengers || !passengers || passengers.length !== originalPassengers.length) {
    return changes;
  }
  for (let index = 0; index < passengers.length; index += 1) {
    const updatedServices = (passengers[index].travelerPreferences || {})
      .selectedSpecialServices || [];
    const services = (originalPassengers[index].travelerPreferences || {})
      .selectedSpecialServices || [];
    const removed = _.differenceBy(services, updatedServices, 'key');
    const added = _.differenceBy(updatedServices, services, 'key');
    if (added.length) {
      added.forEach((s) => {
        changes.push({
          passenger: passengers[index],
          service: s,
          action: 'Selected',
        });
      });
    }
    if (removed.length) {
      removed.forEach((s) => {
        changes.push({
          passenger: passengers[index],
          service: s,
          action: 'Unselected',
        });
      });
    }
  }
  return changes;
};

export default getSpecialServicesChanges;
